<template>
  <v-dialog v-model="internalShow" persistent max-width="290">
    <v-card>
      <v-card-title class="text-h5">{{ title }}</v-card-title>
      <v-card-text>
        <v-color-picker v-model="internalValue" flat></v-color-picker>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn large class="close-btn" @click="internalShow = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      internalValue: this.value,
      internalShow: this.show,
    }
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
    show(newShow) {
      this.internalShow = newShow;
    },
    internalValue(newValue) {
      this.$emit('input', newValue);
    },
    internalShow(newShow) {
      this.$emit('update:show', newShow);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/theme.scss";
.close-btn {
  color: white;
  background-color: $ausloans-blue !important;
}
</style>